import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import { useMediaQuery } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { Typography } from "@mui/material";
import InstiBilling from "./InstiBilling";
import { useState } from "react";
import DNC_List from "./DNC_List";
import FMS_PO_List from "./FMS_PO_List";
import { useParams, useNavigate } from "react-router-dom";
import ISP_List from "./ISP_List";
import Planogram_List from "./Planogram_List";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(0)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(0)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Sidebar({}) {
  const theme = useTheme();
  const open = useSelector((state) => state.common?.openSideBar);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [margin, setMargin] = useState(0);
  const [ref, setRef] = useState();
  React.useEffect(() => {
    if (ref) {
      setMargin(ref.clientHeight);
    }
  }, [ref]);

  return (
    <>
      <Box height={30} />
      <Box
        sx={{
          display: "flex",
          background: "linear-gradient(to bottom, #f2f6fc, #353d47)",
        }}
      >
        <CssBaseline />
        <Drawer variant="permanent" open={open || !isSmallScreen}>
          <DrawerHeader>
            <IconButton>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <div
            style={{
              overflowY: "auto",
              marginBottom: margin,
            }}
          >
            <Stack direction={"column"} spacing={-4}>
              <Typography
                style={{
                  padding: "1.5rem 1.2rem 1rem",
                  fontSize: ".7rem",
                  fontWeight: "bolder",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  color: "#a7aeb8",
                  fontFamily: `"Metropolis", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
                }}
              >
                USER MODULES
              </Typography>
              {/* <AssortmentList />
              <IndentList />
              <ManualToList />
              <TOManagementList />
              <POManagement />
              <InvoiceMatchingList />
              <PBI /> */}
              {/* <MDMList /> */}
              {/* <InstiBilling />
              <DNC_List />
              <FMS_PO_List />
              <ISP_List /> */}
              <Planogram_List />
              {/* <Visibility />
              <AutoDelisting />
              <Promos />
              <VisibilityV2List />
              <TOT />
              <ApiRegistration />
              <VendorPortal />
              <InstiBilling />
              <Subscriptions />
              <Auction />
              <OCP />
              <DarkSaberList /> */}
              {/* <Typography
                style={{
                  padding: "2rem 1.2rem 1rem",
                  fontSize: ".9rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  color: "#a7aeb8",
                }}
              >
                SETTINGS
              </Typography>
              <SettingsList /> */}
            </Stack>
            {/* <Divider /> */}
          </div>
          <div
            ref={setRef}
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: "white",
            }}
          >
            <Typography
              variant={"subtitle1"}
              paddingX={2}
              paddingY={1}
              style={{
                height: 100,
                padding: "2rem 1.2rem 1rem",
                fontSize: ".9rem",
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                color: "#a7aeb8",
              }}
            >
              {/* Logged in as: Superadmin */}
            </Typography>
          </div>
        </Drawer>
      </Box>
    </>
  );
}
